import {useApi} from "../Api";
import {SelectElementModelBE} from "../types/generic";

export const useProviderRepository = () => {
    const {GET} = useApi();

    const PATH = "/pricing/provider";

    function getProviders(): Promise<SelectElementModelBE[]> {
        return GET(`${PATH}/list`);
    }


    return {getProviders};
};